import { useMutation } from '@tanstack/react-query';

import { getBookingEndpoint } from 'reservations/base/constants/endpoints';
import {
  type BookingMutationResponse,
  BookingMutationResponseSchema
} from 'reservations/booking/types';
import { restClient } from 'utility/restClient';
import type { RequestError } from 'utility/restClient';

export const useRemoveGuestMutation = (
  visitId: string,
  onSuccess: () => void
) =>
  useMutation<BookingMutationResponse, RequestError>({
    mutationKey: ['REMOVE_GUEST'],
    mutationFn: async () => {
      const endpoint = getBookingEndpoint(visitId, 'guests');
      const response = await restClient.delete(endpoint);

      try {
        return BookingMutationResponseSchema.parse(response);
      } catch (err) {
        console.error('useRemoveGuestMutation: ', err);
        throw err;
      }
    },
    onSuccess: _data => {
      onSuccess();
    },
    onError: _error => {}
  });
